import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const uat: IPartnerAppSettings = {
  cdnBaseUrl: '',
  serviceEndPoints: [
    {
      clientId: '181ef486-9e47-4ad6-9454-7a326432dc00',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/dmuat/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v1/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v2.0/'
    },
    {
      clientId: 'c1df0735-5f8f-4429-9977-80e732362bdd',
      serviceEndPoint: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/'
    },
    {
      clientId: '00000003-0000-0000-c000-000000000000',
      serviceEndPoint: 'https://graph.microsoft.com/'
    },
    {
      clientId: 'api://b68ad24f-c1d9-4b37-b42f-9564a4609b2f',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/csp-uat-api/'
    },
    {
      clientId: 'c5779b49-c238-45cb-8974-36958d4c7d96',
      serviceEndPoint: 'https://cspa-c6c9afejfggbfxhe.westus-01.azurewebsites.net/'
    },
    {
      clientId: 'c5779b49-c238-45cb-8974-36958d4c7d96',
      serviceEndPoint: 'http://localhost:4000/'
    }
  ],
  ReactDmAppConfiguration: {
    apimSubscriptionKey: '3826a98f41b246fb9d962e132d1d9d34',
    cspSubscriptionKey: '92af6c717f5b4f2c9a41db17e17cc947',
    dmServiceBaseUri: 'https://professionalservicesint.microsoft.com/dmuat/',
    cspBaseUrl: 'https://professionalservicesint.microsoft.com/csp-uat-api/',
    oneProfileBaseUrl: 'https://oneprofileuatapipack.azurefd.net/',
    oneProfileGraphQlBaseUrl: 'https://preprod.apis.profileskills.microsoft.com/',
    oneProfileGraphQLPageSize: 1000,
    esxpBaseUrl: 'https://servicesuat.microsoft.com/#/',
    rmexBaseUrl: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/',
    msxOpportunityUrl: 'https://msxuat.crm.dynamics.com/main.aspx?etn=opportunity&pagetype=entityrecord&id=%s',
    roleIds: '28,161,165,193',
    graphBaseApi: 'https://graph.microsoft.com/v1.0/',
    cspaBaseUrl: 'https://cspa-c6c9afejfggbfxhe.westus-01.azurewebsites.net',
    rmexProgramsBaseUrl: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net',
    deliveryBaseUrl: 'https://professionalservicesint.microsoft.com/dmuat/',
    esxpUrl: 'servicesuat.microsoft.com'
  }
};
